import { Link } from '@ria-client/tw-shared-ui/layout/link';
import { cn } from 'cn';
import type { ReactNode } from 'react';

export type LinkCardProps = {
  href: string;
  children: ReactNode;
  layout?: 'row' | 'column';
  tone?: 'default' | 'highlight';
};

export function LinkCard({ href, children, layout = 'column', tone = 'default' }: LinkCardProps) {
  return (
    <Link
      href={href}
      className={cn(
        'flex rounded-card border border-border p-4 text-inherit no-underline transition-[border-color,box-shadow] hover:border-primary hover:shadow-sm focus-visible:focus-ring',
        layout === 'row' ? 'flex-row items-center gap-4' : 'flex-col items-stretch',
        tone === 'highlight' ? 'bg-accent' : 'bg-card',
      )}
    >
      {children}
    </Link>
  );
}
